import { Input, Label } from '@platform/ui';
import { type ComponentProps, useId } from 'react';

export function Field({
  label,
  hint,
  ...props
}: ComponentProps<typeof Input> & { label: string; hint?: string }) {
  const id = useId();
  return (
    <div className="flex flex-col gap-1.5">
      <Label htmlFor={id}>{label}</Label>
      <Input
        id={id}
        // Emails: sin corrector ni mayúscula automática (en móvil la primera letra se capitaliza).
        {...(props.type === 'email' ? { spellCheck: false, autoCapitalize: 'off' } : {})}
        {...props}
      />
      {hint ? <p className="text-xs text-muted-foreground">{hint}</p> : null}
    </div>
  );
}

export function FormError({ message }: { message: string | null }) {
  return (
    <p role="alert" aria-live="polite" className="min-h-5 text-sm text-destructive">
      {message ?? ''}
    </p>
  );
}

/** Lee un campo de un FormData como string (vacío si falta). */
export function fd(form: FormData, name: string): string {
  const v = form.get(name);
  return typeof v === 'string' ? v : '';
}
